import React, { useState, forwardRef, useEffect } from "react";
import {$host} from '../../../../http'

import * as dayjs from "dayjs";

import ButtonBase from "../buttons/ButtonBase";

import DatePicker from 'react-datepicker'
import ru from 'date-fns/locale/ru'
import {useNotifications} from "../../../../store/NotificationContext";

import 'react-datepicker/dist/react-datepicker.css'


const StreamDateTime = ({ onClose, onSubmit }) => {

    const [dateStart, setDateStart] = useState(dayjs().toDate());
    const [timeStart, setTimeStart] = useState(dayjs().add(1, 'hour').startOf('hour').toDate())
    const {showNotification} = useNotifications();

    const createStreamRoom = () => {
        const d = dayjs(dateStart)
        const t = dayjs(timeStart)
        const scheduleDate = d.set('hour', t.get('hour')).set('minute', t.get('minute')).format('YYYY-MM-DD HH:mm')
        onSubmit(scheduleDate)
        onClose()
    }

    const PickerTrigger = forwardRef(
        ({ value, onClick, label, format }, ref) => (
          <button onClick={onClick} ref={ref} className="border min-w-[160px] border-lavender rounded-2xl min-h-[42px] border-solid flex items-center justify-center px-2 lowercase font-medium">
            {value ? <span>{dayjs(value).format(format)}</span> : <span className="text-lavender-30">{label}</span>}
          </button>
        ),
      );

    return (
        <div className="z-50 fixed top-0 bottom-0 left-0 right-0 ">
            <div className=" fixed top-0 bottom-0 left-0 right-0 bg-black/30" onClick={onClose} />
            <div className="w-[448px] h-[300px] bg-white rounded-2xl fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pt-8 pb-10 px-12">
                <div className="w-full h-full flex flex-col gap-10 justify-end relative">
                    <div className="absolute top-0 right-0 cursor-pointer" onClick={onClose}>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.29297 18.5391C0.882812 18.1406 0.894531 17.4609 1.29297 17.0625L8.79297 9.55078L1.29297 2.05078C0.894531 1.65234 0.894531 0.984375 1.29297 0.574219C1.69141 0.152344 2.38281 0.164062 2.78125 0.574219L10.2812 8.07422L17.7812 0.574219C18.1797 0.164062 18.8594 0.164062 19.2695 0.574219C19.6797 0.972656 19.668 1.65234 19.2695 2.05078L11.7695 9.55078L19.2695 17.0625C19.668 17.4609 19.668 18.1289 19.2695 18.5391C18.8711 18.9492 18.1797 18.9375 17.7812 18.5391L10.2812 11.0391L2.78125 18.5391C2.38281 18.9375 1.70312 18.9375 1.29297 18.5391Z" fill="#363645" />
                        </svg>
                    </div>
                    <div className="flex flex-col gap-8">
                        <h4 className="text-[32px] font-medium">Дата и время старта</h4>
                        <div className="w-full flex items-center justify-center gap-2">
                            <div>
                            <DatePicker
                                selected={dateStart}
                                onChange={(date) => setDateStart(date)}
                                minDate={dayjs()}
                                dateFormat="yyyy-MM-dd"
                                locale={ru}
                                customInput={<PickerTrigger value={dateStart} format="DD.MM.YYYY" label="дд.мм.гггг" />}
                            />
                            </div>
                            <div>
                                <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 1.144V0.0719995H16V1.144H0Z" fill="white" />
                                    <path d="M0 1.144V0.0719995H16V1.144H0Z" fill="#6446C3" />
                                </svg>

                            </div>
                            <div>
                            <DatePicker
                                selected={timeStart}
                                onChange={(time) => {setTimeStart(time)}}
                                dateFormat="yyyy-MM-dd HH:mm"
                                locale={ru}
                                minDate={dayjs()}
                                showTimeSelect
                                showTimeSelectOnly
                                showTimeCaption={false}
                                timeIntervals={30}
                                customInput={<PickerTrigger value={timeStart} format="HH:mm" label="ЧЧ:ММ ПО МСК" />}
                            />
                            </div>
                        </div>
                    </div>
                    <ButtonBase onClick={createStreamRoom}>Применить</ButtonBase>
                </div>
            </div>
        </div>
    )
}

export default StreamDateTime